module.exports = __webpack_public_path__ + "static/media/MarkerPredicYellow.fc67d7a7.svg";